import React, { useMemo, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Form from "react-bootstrap/Form";
import { Col, Row } from "react-bootstrap";
import InfoIcon from "../GFSRulesIcon/InfoIcon";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import AddIcon from "../GFSRulesIcon/AddIcon";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import SingleSelectSearch from "./SingleSelectSearch";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { Autocomplete, Checkbox } from "@mui/material";
import { Controller } from "react-hook-form";
import { SelectOne } from "./SelectOneGfs";
import {
  cabinClassList,
  cabinClassMatchModeList,
  currencyList,
  interlineList,
  passengerTypeList,
  priceSourceList,
  statusList,
  tripTypeList,
} from "src/utils/Currency";
import SingleSelectWithSearch from "./SingleSelectWithSearch";
import { once } from "lodash";

const AddNewFeeRule = ({
  register,
  errors,
  control,
  airportDropdown = [],
  dropDownList = [],
  watch,
  handleEditFeeRule,
  editFeeRuleId,
  duplicateFeeRuleId,
}) => {
  const allOptions = useMemo(() => {
    return Object.entries(dropDownList || {}).map(([key, value]) => ({
      key,
      value,
    }));
  }, [dropDownList]);

  const suppressState = watch("suppress");
  const oncePerCheckState = watch("oncePerCheck");
  const minSegmentsState = watch("minSegments");
  const watchDiscountType = watch("discountType");
  const watchFeeAmtCrr = watch("feeAmtCrr");
  const watchFeeAmtPrice = watch("feeAmtPrice");
  // fee percent
  const watchfeePerDiscount = watch("feePercentDiscount");
  const watchfeePerPrice = watch("feePercentPrice");

  const feePercentRequire = !!watchfeePerDiscount || !!watchfeePerPrice;

  const anyFilled =
    !!watchDiscountType || !!watchFeeAmtCrr || !!watchFeeAmtPrice;
    const watchOncePerBooking = watch([
      "oncePerBookingFeeAmtCurr",
      "oncePerBookingFeeAmtPrice",
    ]);
    const watchMinPrice = watch(["minPriceCurr", "minPriceAmt"]);
    const watchMaxPrice = watch(["maxPriceCurr", "maxPriceAmt"]);

  return (
    <Box component="div" sx={{ p: { xs: 0, md: 2 } }}>
      <Typography
        variant="h6"
        component="h6"
        sx={{ fontSize: 16, fontWeight: "500", mb: 3 }}
      >
        {editFeeRuleId ? "Edit" : duplicateFeeRuleId ? "Duplicate" : "Add New"}{" "}
        Fee Rule {editFeeRuleId && "(ID:" + editFeeRuleId + ")"}
        {duplicateFeeRuleId && "(ID:" + duplicateFeeRuleId + ")"}
      </Typography>

      <div className="addfeeruleitem">
        {/* <form> */}
        <Row>
          <Col sm={6} md={4} lg={4}>
            <Form.Group className="formGroup mb-4" controlId="formGroup">
              <InputLabel
                htmlFor="carrier"
                sx={{
                  fontSize: "12px",
                  color: "#8E8E8E",
                  marginBottom: "-8px",
                  marginLeft: "12px",
                  display: "flex",
                  alignItems: "center",
                  columnGap: "4px",
                  backgroundColor: "#fff",
                  position: "relative",
                  zIndex: 1,
                  width: "fit-content",
                }}
              >
                Carrier
                <Tooltip
                  title="For all airlines: Use All"
                  arrow
                  placement="top"
                >
                  <Button sx={{ padding: "0px", minWidth: "0px" }}>
                    <InfoIcon />
                  </Button>
                </Tooltip>
              </InputLabel>

              <Controller
                name="carrier"
                control={control}
                defaultValue=""
                rules={{ required: true }}
                render={({ field: { onChange, value, ref } }) => {
                  // Find the option object for current value
                  const selectedOption =
                    allOptions.find((opt) => opt.value === value) || null;

                  return (
                    <Autocomplete
                      freeSolo
                      options={allOptions.map((opt) => opt.key)}
                      value={selectedOption ? selectedOption.key : value}
                      onChange={(event, newValue) => {
                        // Map label (key) back to value or use raw string if freeSolo input
                        const matchedOption = allOptions.find(
                          (opt) => opt.key === newValue
                        );
                        onChange(
                          matchedOption ? matchedOption.value : newValue || ""
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          inputRef={ref}
                          variant="outlined"
                          placeholder="Select or type carrier"
                          sx={{
                            width: "100%",
                            "& .MuiOutlinedInput-root": {
                              paddingTop: "0px",
                              height: "50px",
                              fontSize: "14px",
                              marginTop: "0px",
                              "& fieldset": {
                                borderColor: "#E2E0E0",
                                paddingTop: "0 !important",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "#4B7BCF",
                              },
                            },
                            "& .MuiAutocomplete-input": {
                              padding: "0px !important",
                            },
                            "& .MuiInputBase-input": {
                              padding: "0px !important",
                              lineHeight: "50px",
                              fontSize: "14px",
                            },
                          }}
                        />
                      )}
                    />
                  );
                }}
              />
              {/* <Autocomplete
                freeSolo
                options={allOptions.map((option) => option.key)}
                renderInput={(params) => (
                  <>
                    <InputLabel
                      htmlFor="rule-name"
                      sx={{
                        fontSize: "12px",
                        color: "#8E8E8E",
                        marginBottom: "-8px",
                        marginLeft: "12px",
                        display: "flex",
                        alignItems: "center",
                        columnGap: "4px",
                        backgroundColor: "#fff",
                        position: "relative",
                        zIndex: 1,
                        width: "fit-content",
                      }}
                    >
                      Carrier
                      <Tooltip
                        title="For a ll airlines: Use All"
                        arrow
                        placement="top"
                      >
                        <Button sx={{ padding: "0px", minWidth: "0px" }}>
                          <InfoIcon />
                        </Button>
                      </Tooltip>
                    </InputLabel>

                    <TextField
                      {...params}
                      {...register("carrier", { required: true })}
                      id="rule-name"
                      variant="outlined"
                      placeholder="Rule Name"
                      InputLabelProps={{ shrink: true }}
                      sx={{
                        width: "100%",
                        "& .MuiOutlinedInput-root": {
                          paddingTop: "0px",
                          height: "50px",
                          fontSize: "14px",
                          marginTop: "0px",
                          "& fieldset": {
                            borderColor: "#E2E0E0",
                            paddingTop: "0 !important",
                          },

                          "&.Mui-focused fieldset": {
                            borderColor: "#4B7BCF",
                          },
                        },
                        "& .MuiAutocomplete-input": {
                          padding: "0px !important",
                        },
                        "& .MuiInputBase-input": {
                          padding: "0px !important",
                          lineHeight: "50px",
                          fontSize: "14px",
                        },
                      }}
                    />
                  </>
                )}
                sx={{
                  width: "100%",
                  fontSize: "14px",
                  paddingTop: "0px",
                }}
              />*/}
              {errors.carrier && (
                <span className="text-danger text-xs">
                  This field is required
                </span>
              )}
            </Form.Group>
          </Col>
          <Col sm={6} md={4} lg={4}>
            <Form.Group className="mb-4" controlId="formGroup">
              <Form.Label>
                *Sequence Number
                <Tooltip
                  title="Rules are processed in order of sequence numbers and the first matching one gets applied.'"
                  arrow
                  placement="top"
                  componentsProps={{
                    tooltip: {
                      sx: {
                        maxWidth: "none",
                        width: 200,
                        fontSize: "11px",
                        whiteSpace: "normal",
                        padding: "10px 12px",
                      },
                    },
                  }}
                >
                  <Button sx={{ padding: "0px", minWidth: "0px" }}>
                    <InfoIcon />
                  </Button>
                </Tooltip>
              </Form.Label>
              <Form.Control
                {...register("sequenceNum", { required: true })}
                type="number"
                placeholder="0"
                onWheel={(e) => e.target.blur()}
              />
              {errors.sequenceNum && (
                <span className="text-danger text-xs">
                  This field is required
                </span>
              )}
            </Form.Group>
          </Col>
          <Col sm={6} md={4} lg={4}>
            <Form.Group className="formGroup mb-4" controlId="formGroup">
              <Form.Label>
                Ticket Date Effective
                <Tooltip
                  title="The fee rule only applies to itineraries with their first flight being on or later date than the specified value in the timezone of origin"
                  arrow
                  placement="top"
                  componentsProps={{
                    tooltip: {
                      sx: {
                        maxWidth: "none",
                        width: 200,
                        fontSize: "11px",
                        whiteSpace: "normal",
                        padding: "10px 12px",
                      },
                    },
                  }}
                >
                  <Button sx={{ padding: "0px", minWidth: "0px" }}>
                    <InfoIcon />
                  </Button>
                </Tooltip>
              </Form.Label>
              <Form.Control
                {...register("ticketingDateEffective")}
                type="date"
                placeholder="2025-06-26"
              />
              <CalendarMonthIcon
                style={{
                  position: "absolute",
                  right: "8px",
                  top: "22px",
                  pointerEvents: "none",
                  color: "#888",
                  zIndex: "1",
                  fontSize: "20px",
                }}
              />
            </Form.Group>
          </Col>
          <Col sm={6} md={4} lg={4}>
            <Form.Group className="formGroup mb-4" controlId="formGroup">
              <Form.Label>
                Ticket Date Discontinue
                <Tooltip
                  title="the fee rule expires on the specified date”"
                  arrow
                  placement="top"
                  componentsProps={{
                    tooltip: {
                      sx: {
                        maxWidth: "none",
                        width: 200,
                        fontSize: "11px",
                        whiteSpace: "normal",
                        padding: "10px 12px",
                      },
                    },
                  }}
                >
                  <Button sx={{ padding: "0px", minWidth: "0px" }}>
                    <InfoIcon />
                  </Button>
                </Tooltip>
              </Form.Label>
              <Form.Control
                {...register("ticketingDateDiscontinue")}
                type="date"
                placeholder="2025-06-26"
              />
              <CalendarMonthIcon
                style={{
                  position: "absolute",
                  right: "8px",
                  top: "22px",
                  pointerEvents: "none",
                  color: "#888",
                  zIndex: "1",
                  fontSize: "20px",
                }}
              />
            </Form.Group>
          </Col>
          <Col sm={6} md={4} lg={4}>
            <Form.Group className="formGroup mb-4" controlId="formGroup">
              <Form.Label>
                Travel Date Effective
                <Tooltip
                  title="the fee rule expires on the specified date”"
                  arrow
                  placement="top"
                  componentsProps={{
                    tooltip: {
                      sx: {
                        maxWidth: "none",
                        width: 200,
                        fontSize: "11px",
                        whiteSpace: "normal",
                        padding: "10px 12px",
                      },
                    },
                  }}
                >
                  <Button sx={{ padding: "0px", minWidth: "0px" }}>
                    <InfoIcon />
                  </Button>
                </Tooltip>
              </Form.Label>
              <Form.Control
                {...register("travelDateEffective")}
                type="date"
                placeholder="2025-06-26"
              />
              <CalendarMonthIcon
                style={{
                  position: "absolute",
                  right: "8px",
                  top: "22px",
                  pointerEvents: "none",
                  color: "#888",
                  zIndex: "1",
                  fontSize: "20px",
                }}
              />
            </Form.Group>
          </Col>
          <Col sm={6} md={4} lg={4}>
            <Form.Group className="formGroup mb-4" controlId="formGroup">
              <Form.Label>
                Travel Date Discontinue
                <Tooltip
                  title="the fee rule expires on the specified date”"
                  arrow
                  placement="top"
                  componentsProps={{
                    tooltip: {
                      sx: {
                        maxWidth: "none",
                        width: 200,
                        fontSize: "11px",
                        whiteSpace: "normal",
                        padding: "10px 12px",
                      },
                    },
                  }}
                >
                  <Button sx={{ padding: "0px", minWidth: "0px" }}>
                    <InfoIcon />
                  </Button>
                </Tooltip>
              </Form.Label>
              <Form.Control
                {...register("travelDateDiscontinue")}
                type="date"
                placeholder="2025-06-26"
              />
              <CalendarMonthIcon
                style={{
                  position: "absolute",
                  right: "8px",
                  top: "22px",
                  pointerEvents: "none",
                  color: "#888",
                  zIndex: "1",
                  fontSize: "20px",
                }}
              />
            </Form.Group>
          </Col>
        </Row>

        <Box
          component="div"
          sx={{
            backgroundColor: "#F7F6F9",
            padding: "8px 16px",
            borderRadius: 1,
            display: "flex",
            justifyContent: "space-between",
            mt: 1,
            mb: 3,
          }}
        >
          <Typography
            component="span"
            sx={{ fontSize: "14px", fontWeight: "500", color: "#111", mb: 0 }}
          >
            Origin / Destination
          </Typography>
        </Box>

        <Row className="align-items-center">
          <Col sm={6} md={6} lg={6}>
            <Controller
              name="origin"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <SingleSelectWithSearch
                  dropDownList={airportDropdown}
                  selectedValue={field.value}
                  setSelectedValue={field.onChange}
                  label="Origin"
                />
              )}
            />

            {/* <FormControl fullWidth>
              <InputLabel
                id="origin-label"
                sx={{
                  fontSize: "14px",
                  fontWeight: "500",
                  color: "#111",
                  marginBottom: "0px",
                }}
              >
                Origin
              </InputLabel>
              <Controller
                name="origin"
                control={control} // from useForm
                defaultValue="" // or your default value
                render={({ field }) => (
                  <Select
                    labelId="origin-label"
                    id="origin-select"
                    label="Origin"
                    {...field}
                    sx={{
                      width: "100%",
                      height: "50px",
                      lineHeight: "4",
                      fontSize: "14px",
                      "& label.Mui-focused": {
                        color: "#4B7BCF",
                      },
                      "&.MuiOutlinedInput-notchedOutline": {
                        borderColor: "#E2E0E0",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#2d65c7",
                      },
                    }}
                  >
                    <MenuItem value={""}>Select Origin</MenuItem>
                    {airportOptions.map((item) => (
                      <MenuItem value={item.value}>{item.key}</MenuItem>
                    ))}
                  </Select>
                )}
              />
            </FormControl> */}
          </Col>

          <Col sm={6} md={6} lg={6}>
            {/* <SingleSelectSearch /> */}
            <Controller
              name="destination"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <SingleSelectWithSearch
                  dropDownList={airportDropdown}
                  selectedValue={field.value}
                  setSelectedValue={field.onChange}
                  label="Destination"
                />
              )}
            />
          </Col>
        </Row>

        <Box
          component="div"
          sx={{
            backgroundColor: "#F7F6F9",
            padding: "8px 16px",
            borderRadius: 1,
            display: "flex",
            justifyContent: "space-between",
            mt: 4,
            mb: 2,
          }}
        >
          <Typography
            component="span"
            sx={{ fontSize: "14px", fontWeight: "500", color: "#111", mb: 0 }}
          >
            Suppress
          </Typography>
          <Tooltip
            title="The sale of the flights with the criteria will be forbidden"
            arrow
            placement="top"
            PopperProps={{
              modifiers: [
                {
                  name: "offset",
                  options: {
                    offset: [0, 8],
                  },
                },
              ],
            }}
            componentsProps={{
              tooltip: {
                sx: {
                  maxWidth: "none",
                  width: 250,
                  fontSize: "13px",
                  padding: "12px 10px",
                  whiteSpace: "normal",
                  fontSize: "11px",
                },
              },
            }}
          >
            <Button sx={{ padding: "0px", minWidth: "0px" }}>
              <InfoIcon />
            </Button>
          </Tooltip>
        </Box>

        <Row>
          <Col md={6} lg={6}>
            <FormControl>
              <Controller
                name="suppress"
                control={control}
                defaultValue={false} // or your initial value
                render={({ field: { onChange, value, ...rest } }) => (
                  <RadioGroup
                    {...rest}
                    value={value === true ? "true" : "false"} // map boolean to string for display
                    onChange={(e) => onChange(e.target.value === "true")} // convert back to boolean
                    sx={{ display: "flex", flexDirection: "row", gap: 2 }}
                    aria-labelledby="demo-radio-buttons-group-label"
                  >
                    <FormControlLabel
                      value="true"
                      control={
                        <Radio
                          sx={{
                            color: "#444",

                            "&.Mui-checked": { color: "#444" },
                          }}
                        />
                      }
                      label="True"
                    />
                    <FormControlLabel
                      value="false"
                      control={
                        <Radio
                          sx={{
                            color: "#444",
                            "&.Mui-checked": { color: "#444" },
                          }}
                        />
                      }
                      label="False"
                    />
                  </RadioGroup>
                )}
              />
            </FormControl>
          </Col>
        </Row>
        <Box
          component="div"
          sx={{
            backgroundColor: "#F7F6F9",
            padding: "8px 16px",
            borderRadius: 1,
            display: "flex",
            justifyContent: "space-between",
            mt: 1,
            mb: 3,
          }}
        >
          <Typography
            component="span"
            sx={{ fontSize: "14px", fontWeight: "500", color: "#111", mb: 0 }}
          >
            Once Per Booking Fee Amount
          </Typography>
          <Tooltip
            title="The rule will match if the passenger price is higher (or equals) than the price specified"
            arrow
            placement="top"
            PopperProps={{
              modifiers: [
                {
                  name: "offset",
                  options: {
                    offset: [0, 8],
                  },
                },
              ],
            }}
            componentsProps={{
              tooltip: {
                sx: {
                  maxWidth: "none",
                  width: 250,
                  fontSize: "13px",
                  padding: "12px 10px",
                  whiteSpace: "normal",
                  fontSize: "11px",
                },
              },
            }}
          >
            <Button sx={{ padding: "0px", minWidth: "0px" }}>
              <InfoIcon />
            </Button>
          </Tooltip>
        </Box>

        <Row>
          <Controller
            name="oncePerCheck"
            control={control}
            render={({ field }) => (
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={suppressState}
                    onChange={(e) => field.onChange(e.target.checked)}
                    {...field}
                    checked={field.value} // important: bind checked to field.value
                  />
                }
                label="Do you want to add this rule?"
                sx={{ mb: 3 }}
              />
            )}
          />
          <Col sm={6} md={4} lg={4}>
            <SelectOne
              disabled={suppressState || !oncePerCheckState}
              control={control}
              name="oncePerBookingFeeAmtCurr"
              id="currency-select2"
              label="Currency"
              optionList={currencyList}
              rules={{
                validate: (value) => {
                  const [curr, price] = watchOncePerBooking;
                  const anyFilled = !!curr || !!price;
                  if (anyFilled && !value)
                    return "Required if other fields are filled";
                  return true;
                },
              }}
            />
            {errors.oncePerBookingFeeAmtCurr && (
              <p className="error text-danger">
                {errors.oncePerBookingFeeAmtCurr.message}
              </p>
            )}
          </Col>
          <Col sm={6} md={4} lg={4}>
            <Form.Group className="" controlId="formGroup">
              <Form.Label style={{ marginTop: "-8px" }}>Amount </Form.Label>
              <Form.Control
                disabled={suppressState || !oncePerCheckState}
                {...register("oncePerBookingFeeAmtPrice", {
                  validate: (value) => {
                    const [curr, price] = watchOncePerBooking;
                    const anyFilled = !!curr || !!price;
                    if (anyFilled && !value)
                      return "Required if other fields are filled";
                    return true;
                  },
                })}
                type="number"
                placeholder="1000"
                onWheel={(e) => e.target.blur()}
              />
              {errors.oncePerBookingFeeAmtPrice && (
                <p className="error text-danger">
                  {errors.oncePerBookingFeeAmtPrice.message}
                </p>
              )}
            </Form.Group>
          </Col>
        </Row>
        <Box
          component="div"
          sx={{
            backgroundColor: "#F7F6F9",
            padding: "8px 16px",
            borderRadius: 1,
            display: "flex",
            justifyContent: "space-between",
            mt: 2,
            mb: 3,
          }}
        >
          <Typography
            component="span"
            sx={{ fontSize: "14px", fontWeight: "500", color: "#111", mb: 0 }}
          >
            Fee Amount
          </Typography>
          <Tooltip
            title="Flat fee per passenger for the flight. The fee amount is applied per passenger."
            arrow
            placement="top"
            PopperProps={{
              modifiers: [
                {
                  name: "offset",
                  options: {
                    offset: [0, 8],
                  },
                },
              ],
            }}
            componentsProps={{
              tooltip: {
                sx: {
                  maxWidth: "none",
                  width: 250,
                  fontSize: "13px",
                  padding: "12px 10px",
                  whiteSpace: "normal",
                  fontSize: "11px",
                },
              },
            }}
          >
            <Button sx={{ padding: "0px", minWidth: "0px" }}>
              <InfoIcon />
            </Button>
          </Tooltip>
        </Box>

        <Row>
          <Col sm={6} md={4} lg={4} className="mb-2">
            <FormControl fullWidth>
              <InputLabel
                id="origin-label"
                sx={{
                  fontSize: "14px",
                  fontWeight: "500",
                  color: "#8E8E8E",
                  "&.Mui-focused": {
                    color: "#4B7BCF",
                  },
                }}
              >
                Discount Type
              </InputLabel>
              <Controller
                name="discountType"
                control={control} // from useForm
                defaultValue="" // or your default value
                rules={{
                  validate: (value) => {
                    if (anyFilled && !value)
                      return "Required if other fields are filled";
                    return true;
                  },
                }}
                render={({ field }) => (
                  <Select
                    disabled={suppressState || oncePerCheckState}
                    labelId="origin-label"
                    id="discount-select"
                    label="Discount Type"
                    {...field}
                    sx={{
                      width: "100%",
                      height: "50px",
                      lineHeight: "4",
                      fontSize: "14px",
                      " & label": {
                        color: "#444",
                      },
                      "& label.Mui-focused": {
                        color: "#4B7BCF",
                      },
                      "&.MuiOutlinedInput-notchedOutline": {
                        borderColor: "#E2E0E0",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#2d65c7",
                      },
                    }}
                  >
                    <MenuItem value={""}>Select</MenuItem>
                    <MenuItem value={"+"}>Markup</MenuItem>
                    <MenuItem value={"-"}>Discount</MenuItem>
                  </Select>
                )}
              />
            </FormControl>
            {errors.discountType && (
              <p className="text-danger text-sm">
                {errors.discountType.message}
              </p>
            )}
          </Col>
          <Col sm={6} md={4} lg={4} className="mb-2">
            <SelectOne
              disabled={suppressState || oncePerCheckState}
              control={control}
              name="feeAmtCrr"
              id="currency-select-feeAmtCrr"
              label="Currency"
              optionList={currencyList}
              rules={{
                validate: (value) => {
                  if (anyFilled && !value)
                    return "Required if other fields are filled";
                  return true;
                },
              }}
            />
            {errors.feeAmtCrr && (
              <p className="text-danger text-sm">{errors.feeAmtCrr.message}</p>
            )}
          </Col>
          <Col sm={6} md={4} lg={4}>
            <Form.Group className="mt-0 mb-2" controlId="formGroup">
              <Form.Label style={{ marginTop: "-8px" }}>Amount </Form.Label>
              <Form.Control
                disabled={suppressState || oncePerCheckState}
                {...register("feeAmtPrice", {
                  validate: (value) => {
                    if (anyFilled && !value)
                      return "Required if other fields are filled";
                    return true;
                  },
                })}
                type="text"
                placeholder="1000"
                name="feeAmtPrice"
                // value={feeAmtPrice}
                // onChange={(e) => setFeeAmtPrice(e.target.value)}
              />
              {errors.feeAmtPrice && (
                <p className="text-danger text-sm">
                  {errors.feeAmtPrice.message}
                </p>
              )}
            </Form.Group>
          </Col>
        </Row>

        <Box
          component="div"
          sx={{
            backgroundColor: "#F7F6F9",
            padding: "8px 16px",
            borderRadius: 1,
            display: "flex",
            justifyContent: "space-between",
            mt: 1,
            mb: 3,
          }}
        >
          <Typography
            component="span"
            sx={{ fontSize: "14px", fontWeight: "500", color: "#111", mb: 0 }}
          >
            Fee Percent
          </Typography>
          <Tooltip
            title="Percentage fee of the whole price, including taxes"
            arrow
            placement="top"
            PopperProps={{
              modifiers: [
                {
                  name: "offset",
                  options: {
                    offset: [0, 8],
                  },
                },
              ],
            }}
            componentsProps={{
              tooltip: {
                sx: {
                  maxWidth: "none",
                  width: 250,
                  fontSize: "13px",
                  padding: "12px 10px",
                  whiteSpace: "normal",
                  fontSize: "11px",
                },
              },
            }}
          >
            <Button sx={{ padding: "0px", minWidth: "0px" }}>
              <InfoIcon />
            </Button>
          </Tooltip>
        </Box>

        <Row>
          <Col sm={6} md={4} lg={4}>
            <FormControl fullWidth>
              <InputLabel
                id="origin-label"
                sx={{
                  fontSize: "14px",
                  fontWeight: "500",
                  color: "#8E8E8E",
                  backgroundColor: "#fff",
                  "&.Mui-focused": {
                    color: "#4B7BCF",
                  },
                }}
              >
                Discount Type
              </InputLabel>
              <Controller
                name="feePercentDiscount"
                control={control} // from useForm
                defaultValue="" // or your default value
                rules={{
                  validate: (value) => {
                    if (feePercentRequire && !value)
                      return "Required if other fields are filled";
                    return true;
                  },
                }}
                render={({ field }) => (
                  <Select
                    disabled={suppressState || oncePerCheckState}
                    labelId="discount-label1"
                    id="discount-select2"
                    label="Discount Type"
                    {...field}
                    sx={{
                      width: "100%",
                      height: "50px",
                      lineHeight: "4",
                      fontSize: "14px",
                      "& label.Mui-focused": {
                        color: "#4B7BCF",
                      },
                      "&.MuiOutlinedInput-notchedOutline": {
                        borderColor: "#E2E0E0",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#2d65c7",
                      },
                    }}
                  >
                    <MenuItem value={""}>Select</MenuItem>
                    <MenuItem
                      value={"+"}
                      sx={{
                        fontSize: "14px",
                      }}
                    >
                      Markup
                    </MenuItem>
                    <MenuItem
                      value={"-"}
                      sx={{
                        fontSize: "14px",
                      }}
                    >
                      Discount
                    </MenuItem>
                  </Select>
                )}
              />
            </FormControl>
            {errors.feePercentDiscount && (
              <p className="text-danger text-sm">
                {errors.feePercentDiscount.message}
              </p>
            )}
          </Col>
          <Col sm={6} md={4} lg={4}>
            <Form.Group className="mb-4" controlId="formGroup">
              <Form.Label style={{ marginTop: "-8px" }}>Amount </Form.Label>
              <Form.Control
                disabled={suppressState || oncePerCheckState}
                {...register("feePercentPrice", {
                  validate: (value) => {
                    if (feePercentRequire && !value)
                      return "Required if other fields are filled";
                    return true;
                  },
                })}
                type="number"
                placeholder="1000"
                onWheel={(e) => e.target.blur()}
              />
              {errors.feePercentPrice && (
                <p className="text-danger text-sm">
                  {errors.feePercentPrice.message}
                </p>
              )}
            </Form.Group>
          </Col>
        </Row>

        <Box
          component="div"
          sx={{
            backgroundColor: "#F7F6F9",
            padding: "8px 16px",
            borderRadius: 1,
            display: "flex",
            justifyContent: "space-between",
            mt: 4,
            mb: 3,
          }}
        >
          <Typography
            component="span"
            sx={{ fontSize: "14px", fontWeight: "500", color: "#111", mb: 0 }}
          >
            TripType / CabinClass / CabinClassMatchMode / PassengerType
          </Typography>
          <Tooltip
            title="The sale of the flights with the criteria will be forbidden"
            arrow
            placement="top"
            PopperProps={{
              modifiers: [
                {
                  name: "offset",
                  options: {
                    offset: [0, 8],
                  },
                },
              ],
            }}
            componentsProps={{
              tooltip: {
                sx: {
                  maxWidth: "none",
                  width: 250,
                  fontSize: "13px",
                  padding: "12px 10px",
                  whiteSpace: "normal",
                  fontSize: "11px",
                },
              },
            }}
          >
            <Button sx={{ padding: "0px", minWidth: "0px" }}>
              <InfoIcon />
            </Button>
          </Tooltip>
        </Box>

        <Row>
          <Col sm={6} md={4} lg={4}>
            <Form.Group className="mb-4" controlId="formGroup">
              <SelectOne
                control={control}
                name="tripType"
                label="Trip Type"
                tooltip="Trip type selector. The rule will only match the itineraries of the specified type."
                id="tripType"
                optionList={tripTypeList}
              />
            </Form.Group>
          </Col>
          <Col sm={6} md={4} lg={4}>
            <Form.Group className="mb-4" controlId="formGroup">
              <SelectOne
                control={control}
                name="cabinClass"
                label="Cabin Class"
                tooltip="Cabin class selector. The rule will only match the flights with the cabin class specified."
                id="cabinClass"
                optionList={cabinClassList}
              />
            </Form.Group>
          </Col>
          <Col sm={6} md={4} lg={4}>
            <Form.Group className="mb-4" controlId="formGroup">
              <SelectOne
                control={control}
                name="cabinClassMatchMode"
                label="Cabin Class Match Mode"
                tooltip="Match mode for cabin class selector. Possible values: LONGEST_SEGMENTS: the rule will match if the longest segments of the outbound and inbound are in the cabin class specified in"
                id="cabinClassMatchMode"
                optionList={cabinClassMatchModeList}
              />
            </Form.Group>
          </Col>
          <Col sm={6} md={4} lg={4}>
            <Form.Group className="mb-4" controlId="formGroup">
              <SelectOne
                control={control}
                name="passengerType"
                label="Passenger Type"
                tooltip="Passenger type selector. The rule will be applied only to passengers with the matching type."
                id="passengerType"
                optionList={passengerTypeList}
              />
            </Form.Group>
          </Col>
        </Row>

        <Box
          component="div"
          sx={{
            backgroundColor: "#F7F6F9",
            padding: "8px 16px",
            borderRadius: 1,
            display: "flex",
            justifyContent: "space-between",
            mt: 1,
            mb: 2,
          }}
        >
          <Typography
            component="span"
            sx={{ fontSize: "14px", fontWeight: "500", color: "#111", mb: 0 }}
          >
            Min Price
          </Typography>
          <Tooltip
            title="The rule will match if the passenger price is higher (or equals) than the price specified"
            arrow
            placement="top"
            PopperProps={{
              modifiers: [
                {
                  name: "offset",
                  options: {
                    offset: [0, 8],
                  },
                },
              ],
            }}
            componentsProps={{
              tooltip: {
                sx: {
                  maxWidth: "none",
                  width: 250,
                  fontSize: "13px",
                  padding: "12px 10px",
                  whiteSpace: "normal",
                  fontSize: "11px",
                },
              },
            }}
          >
            <Button sx={{ padding: "0px", minWidth: "0px" }}>
              <InfoIcon />
            </Button>
          </Tooltip>
        </Box>

        <Row>
          <Col sm={6} md={4} lg={4}>
            <SelectOne
              disabled={oncePerCheckState}
              control={control}
              name="minPriceCurr"
              id="currency"
              label="Currency"
              optionList={currencyList}
              rules={{
                validate: (value) => {
                  const [curr, amt] = watchMinPrice;
                  const anyFilled = !!curr || !!amt;
                  if (anyFilled && !value)
                    return "Required if other fields are filled";
                  return true;
                },
              }}
            />
            {errors.minPriceCurr && (
              <span className="text-danger text-sm">
                {errors.minPriceCurr.message}
              </span>
            )}
          </Col>
          <Col sm={6} md={4} lg={4}>
            <Form.Group className="mb-4" controlId="formGroup">
              <Form.Label>Amount </Form.Label>
              <Form.Control
                disabled={oncePerCheckState}
                {...register("minPriceAmt", {
                  validate: (value) => {
                    const [curr, amt] = watchMinPrice;
                    const anyFilled = !!curr || !!amt;
                    if (anyFilled && !value)
                      return "Required if other fields are filled";
                    return true;
                  },
                })}
                type="text"
                placeholder="1000"
              />
              {errors.minPriceAmt && (
                <span className="text-danger text-sm">
                  {errors.minPriceAmt.message}
                </span>
              )}
            </Form.Group>
          </Col>
        </Row>

        <Box
          component="div"
          sx={{
            backgroundColor: "#F7F6F9",
            padding: "8px 16px",
            borderRadius: 1,
            display: "flex",
            justifyContent: "space-between",
            mt: 1,
            mb: 2,
          }}
        >
          <Typography
            component="span"
            sx={{ fontSize: "14px", fontWeight: "500", color: "#111", mb: 0 }}
          >
            Max Price
          </Typography>
          <Tooltip
            title="The rule will match if the passenger price is lower (or equals) than the price specified."
            arrow
            placement="top"
            PopperProps={{
              modifiers: [
                {
                  name: "offset",
                  options: {
                    offset: [0, 8],
                  },
                },
              ],
            }}
            componentsProps={{
              tooltip: {
                sx: {
                  maxWidth: "none",
                  width: 250,
                  fontSize: "13px",
                  padding: "12px 10px",
                  whiteSpace: "normal",
                  fontSize: "11px",
                },
              },
            }}
          >
            <Button sx={{ padding: "0px", minWidth: "0px" }}>
              <InfoIcon />
            </Button>
          </Tooltip>
        </Box>

        <Row>
          <Col sm={6} md={4} lg={4}>
            <SelectOne
              disabled={oncePerCheckState}
              control={control}
              name="maxPriceCurr"
              id="currency"
              label="Currency"
              optionList={currencyList}
              rules={{
                validate: (value) => {
                  const [curr, amt] = watchMaxPrice;
                  const anyFilled = !!curr || !!amt;
                  if (anyFilled && !value)
                    return "Required if other fields are filled";
                  return true;
                },
              }}
            />
            {errors.maxPriceCurr && (
              <span className="text-danger text-sm">
                {errors.maxPriceCurr.message}
              </span>
            )}
          </Col>
          <Col sm={6} md={4} lg={4}>
            <Form.Group className="mb-4" controlId="formGroup">
              <Form.Label>Amount </Form.Label>
              <Form.Control
                disabled={oncePerCheckState}
                {...register("maxPriceAmt", {
                  validate: (value) => {
                    const [curr, amt] = watchMaxPrice;
                    const anyFilled = !!curr || !!amt;
                    if (anyFilled && !value)
                      return "Required if other fields are filled";
                    return true;
                  },
                })}
                type="text"
                placeholder="1000"
              />
            </Form.Group>
            {errors.maxPriceAmt && (
              <span className="text-danger text-sm">
                {errors.maxPriceAmt.message}
              </span>
            )}
          </Col>
        </Row>

        <Box
          component="div"
          sx={{
            backgroundColor: "#F7F6F9",
            padding: "8px 16px",
            borderRadius: 1,
            display: "flex",
            justifyContent: "space-between",
            mt: 1,
            mb: 2,
          }}
        >
          <Typography
            component="span"
            sx={{ fontSize: "14px", fontWeight: "500", color: "#111", mb: 0 }}
          >
            Interline / SliceInterline / PassengerType / MinTotalSegments /
            MaxHoursToDeparture / PriceSource
          </Typography>
        </Box>

        <Row>
          <Col sm={6} md={4} lg={4}>
            <Form.Group className="mb-4" controlId="formGroup">
              <SelectOne
                control={control}
                name="interline"
                id="interline"
                label="Interline"
                tooltip={
                  "The rule will only match trips with 2 or more marketing carriers"
                }
                optionList={interlineList}
              />
            </Form.Group>
          </Col>
          <Col sm={6} md={4} lg={4}>
            <Form.Group className="mb-4" controlId="formGroup">
              <SelectOne
                control={control}
                name="sliceInterline"
                id="sliceInterline"
                label="Slice Interline"
                tooltip={
                  "The rule will only trips with 2 or more marketing carriers on the outbound and/or the inbound"
                }
                optionList={interlineList}
              />
            </Form.Group>
          </Col>
          <Col sm={6} md={6} lg={4}>
            <Form.Group className="mb-4" controlId="formGroup">
              <Form.Label>
                Min Segments
                <Tooltip
                  title="Selector for minimum amount of segments.
For one-way flights, will match the itinerary with at least the specified number of segments.
For round-trip flights, will match the itinerary if its inbound or outbound contains at least the specified number of segments (note that it is not required for both outbound and inbound to have the specified number of segments, 
either is enough for the match"
                  arrow
                  placement="top"
                  PopperProps={{
                    modifiers: [
                      {
                        name: "offset",
                        options: {
                          offset: [0, 8],
                        },
                      },
                    ],
                  }}
                  componentsProps={{
                    tooltip: {
                      sx: {
                        maxWidth: "none",
                        width: 250,
                        fontSize: "13px",
                        padding: "12px 10px",
                        whiteSpace: "normal",
                        fontSize: "11px",
                      },
                    },
                  }}
                >
                  <Button sx={{ padding: "0px", minWidth: "0px" }}>
                    <InfoIcon />
                  </Button>
                </Tooltip>
              </Form.Label>
              <Form.Control
                disabled={watch("minTotalSegments") > 0}
                {...register("minSegments")}
                type="number"
                placeholder="0"
                onWheel={(e) => e.target.blur()}
              />
            </Form.Group>
          </Col>
          <Col sm={6} md={6} lg={4}>
            <Form.Group className="mb-4" controlId="formGroup">
              <Form.Label>
                minTotalSegments
                <Tooltip
                  title="Alternative selector for minimum total amount of segments. For one-way flights, will match the itinerary with at least the specified number of segments. For round-trip flights, will match the itinerary if the total number of segments on its inbound and outbound is at least the specified number of segments. "
                  arrow
                  placement="top"
                  PopperProps={{
                    modifiers: [
                      {
                        name: "offset",
                        options: {
                          offset: [0, 8],
                        },
                      },
                    ],
                  }}
                  componentsProps={{
                    tooltip: {
                      sx: {
                        maxWidth: "none",
                        width: 250,
                        fontSize: "13px",
                        padding: "12px 10px",
                        whiteSpace: "normal",
                        fontSize: "11px",
                      },
                    },
                  }}
                >
                  <Button sx={{ padding: "0px", minWidth: "0px" }}>
                    <InfoIcon />
                  </Button>
                </Tooltip>
              </Form.Label>
              <Form.Control
                disabled={minSegmentsState}
                {...register("minTotalSegments")}
                type="number"
                placeholder="0"
                onWheel={(e) => e.target.blur()}
              />
            </Form.Group>
          </Col>
          <Col sm={6} md={6} lg={4}>
            <Form.Group className="mb-4" controlId="formGroup">
              <Form.Label>
                maxHoursToDeparture
                <Tooltip
                  title="Selector for time to flight departure (advance purchase window). Will match the itinerary if the time to departure of its first flight is less than the specified amount of hours."
                  arrow
                  placement="top"
                  PopperProps={{
                    modifiers: [
                      {
                        name: "offset",
                        options: {
                          offset: [0, 8],
                        },
                      },
                    ],
                  }}
                  componentsProps={{
                    tooltip: {
                      sx: {
                        maxWidth: "none",
                        width: 250,
                        fontSize: "13px",
                        padding: "12px 10px",
                        whiteSpace: "normal",
                        fontSize: "11px",
                      },
                    },
                  }}
                >
                  <Button sx={{ padding: "0px", minWidth: "0px" }}>
                    <InfoIcon />
                  </Button>
                </Tooltip>
              </Form.Label>
              <Form.Control
                {...register("maxHoursToDeparture")}
                type="number"
                placeholder="0"
                onWheel={(e) => e.target.blur()}
              />
            </Form.Group>
          </Col>
          <Col sm={6} md={4} lg={4}>
            <Form.Group className="mb-4" controlId="formGroup">
              <SelectOne
                control={control}
                name="priceSource"
                label="Price Source"
                tooltip={
                  "GDS : the rule will apply to prices coming from GDS. The base price will match the public GDS fares for this carrier or OTA specific configuration (e.g. Amadeus office ids) if that was provided to Google via email - not part of this file."
                }
                optionList={priceSourceList}
              />
            </Form.Group>
          </Col>
          <Col sm={6} md={4} lg={4}>
            <Form.Group className="mb-4" controlId="formGroup">
              <SelectOne
                control={control}
                name="status"
                label="Status"
                optionList={statusList}
              />
            </Form.Group>
          </Col>
        </Row>
        <div className="d-flex justify-content-end">
          <Button
            type="submit"
            variant="contained"
            size="medium"
            sx={{
              width: 200,
              backgroundColor: "#4B7BCF",
              boxShadow: 0,
              color: "#fff",
              borderRadius: 1,
              "&:hover": {
                backgroundColor: "#2d65c7",
              },
            }}
          >
            {editFeeRuleId ? "Update" : "Submit"}
          </Button>
        </div>

        {/* </form> */}
      </div>
    </Box>
  );
};

export default AddNewFeeRule;
